import React from "react"
import { useNavigate } from "react-router-dom"
import _ from "lodash"
import { LibraryBooksOutlined } from "@mui/icons-material"
import { Loader } from "../../components/index"
import { useGetMyCoursesQuery } from "../../Redux/actions/lecture.action"
import { learnPaths } from "../constants"
import CourseCard from "../components/CourseCard"
import EmptyState from "../components/EmptyState"

/** Only the courses this student has enrolled in. */
export default function MyCoursesPage() {
    const navigate = useNavigate()
    const { data, isLoading, isError, error, refetch } = useGetMyCoursesQuery()

    const courses = React.useMemo(() => _.get(data, "list", []), [data])

    const totalLectures = React.useMemo(
        () => _.sumBy(courses, (item) => item.lecture_count || 0),
        [courses]
    )

    return (
        <div className="space-y-6">

            <header>
                <h1 className="text-xl font-bold text-slate-800 sm:text-2xl">
                    My Courses
                </h1>
                <p className="mt-1 text-sm text-slate-500">
                    {courses.length}{" "}
                    {courses.length === 1 ? "course" : "courses"} ·{" "}
                    {totalLectures}{" "}
                    {totalLectures === 1 ? "lecture" : "lectures"} to watch
                </p>
            </header>

            {isError && (
                <EmptyState
                    icon={<LibraryBooksOutlined />}
                    title="Couldn't load your courses"
                    description={
                        _.get(error, "data.detail", null) ||
                        "Please check your connection and try again."
                    }
                    actionLabel="Retry"
                    onAction={refetch}
                />
            )}

            {!isLoading && !isError && courses.length === 0 && (
                <EmptyState
                    icon={<LibraryBooksOutlined />}
                    title="You haven't enrolled in anything yet"
                    description="Browse the catalogue and enrol in a course to start watching its lectures."
                    actionLabel="Browse courses"
                    onAction={() => navigate(learnPaths.home)}
                />
            )}

            {courses.length > 0 && (
                <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {courses.map((course) => (
                        <CourseCard
                            key={course.course_id}
                            course={{ ...course, is_enrolled: true }}
                            onOpen={() =>
                                navigate(learnPaths.course(course.course_id))
                            }
                            onBuy={() =>
                                navigate(learnPaths.course(course.course_id))
                            }
                        />
                    ))}
                </section>
            )}

            {isLoading && <Loader show={true} message="Loading your courses..." />}
        </div>
    )
}
